import React from 'react'
import {connect} from 'react-redux'
import {fetchClients, setOpened, setClientSubModule, fetchClientOptionsDict, initializeProfileForm, toggleModalClientProfileForm, setClientData} from 'state/actions'
import i18n from 'lib/i18n'
import ClientZoom from './clientZoom'
import ClientsForm from './form'
import ClientResults from './clientResults'
import styles from './clients.scss'

const _ = i18n('clients')

@connect(state => {
    const clientAccess = state.app.security.actions

    let canCreateClient,canUpdateClient

    clientAccess.map((item, key) => {
        if(item.actionName == 'createclient')
        {
            canCreateClient = item.actionAllowed === "true" ? true : false
        }

        if(item.actionName == 'modifyclient')
        {
            canUpdateClient = item.actionAllowed === "true" ? true: false
        }
    })

    return ({
        data: state.clients.data,
        lang: state.app.lang,
        clientOptionsDict: state.client.clientOptionsDict,
        opened: state.app.opened,
        createClientAccess: canCreateClient,
        updateClientAccess: canUpdateClient,
        initializeProfileForm,
        toggleModalClientProfileForm,
        modalState: state.clientProfileForm.clientModal
    })
})
export default class Clients extends React.Component {
	static propTypes = {
		dispatch: React.PropTypes.func.isRequired,
		opened: React.PropTypes.string,
		lang: React.PropTypes.string,
        data: React.PropTypes.array,
        clientOptionsDict: React.PropTypes.object
	}

    constructor(props) {
        super(props)
    }

    componentWillMount() {
        const {dispatch, initializeProfileForm, clientOptionsDict} = this.props

        if (!clientOptionsDict || Object.keys(clientOptionsDict).length == 0) {
            dispatch(fetchClientOptionsDict())
        }
    }

	handleSearch = data => this.props.dispatch(fetchClients(data))

	zoomClient = id => {
		const {dispatch} = this.props
		dispatch(setOpened(id))
		dispatch(setClientSubModule())
	}

    openModal(e) {
		e.preventDefault()
		const { dispatch, initializeProfileForm, toggleModalClientProfileForm, modalState } = this.props

		dispatch(toggleModalClientProfileForm(!modalState))
		dispatch(initializeProfileForm({}, null, 'create'))
    }

    componentWillUnmount() {
        const {dispatch} = this.props
		dispatch(setClientData({}))
	}

    render() {
		const {data, opened, createClientAccess, updateClientAccess, modalState, clientOptionsDict} = this.props

        const openModal = (e) => {
            this.openModal(e)
        }

		return (
			<div className={styles.clientsMain}>
				<div className={`${styles.clientsSearchContainer} ${opened ? styles.hidden : 'visible'}`}>
					<div className={`main-title-div`}>
						<div className={`main-title-container`}>
							<h2 className={`main-title`}>{_('title')}</h2>
							<h3>{_('subtitle')}</h3>
						</div>
					</div>
					<ClientsForm
						{...{
                            createClientAccess,
                            updateClientAccess,
                            openModal,
                            modalState
                        }}
						onSubmit={this.handleSearch}
                        initialValues={{state: ''}}
                        clientOptionsDict={clientOptionsDict}
                        lang={lang}
					/>
					{data &&
						<ClientResults data={data} zoomTo={this.zoomClient}/>
					}
				</div>
				{opened && <ClientZoom/>}
			</div>
		)}
	}



// WEBPACK FOOTER //
// ./components/clients/index.jsx